import {ValueListInterface} from "../Interfaces/ValueListInterface";

export class AttributeValue implements ValueListInterface {
    readonly id: number;
    private _name: string;
    private _description: string;
    private _systemRequired: boolean;

    constructor(id: number, name: string, description: string, systemRequired: boolean) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.systemRequired = systemRequired;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get description(): string {
        return this._description;
    }

    set description(value: string) {
        this._description = value;
    }

    get systemRequired(): boolean {
        return this._systemRequired;
    }

    set systemRequired(value: boolean) {
        this._systemRequired = value;
    }

    clone(): AttributeValue {
        return new AttributeValue(this.id, this.name, this.description, this.systemRequired);
    }

    equal(value: AttributeValue): boolean {
        if (!value) {
            return false
        }
        if (this.name.trim() != value.name.trim()) {
            return false;
        }
        if (this.systemRequired !== value.systemRequired) {
            return false;
        }
        return this.description.trim() == value.description.trim();
    }

    isValid(): { valid: boolean, data: Map<string, { valid: boolean, msg: string }> } {
        const data = new Map([
            ["name", {
                valid: this.name.trim() !== "",
                msg: this.name.trim() === "" ? "Attribute Value name can't be an empty string." : null
            }],
            ["description", {
                valid: this.description.trim() !== "",
                msg: this.description.trim() === "" ? "Attribute Value description can't be an empty string." : null
            }]
        ]);
        return {valid: !Array.from(data.values()).some(item => item.valid === false), data}
    }

    isErasable(): { erasable: boolean; msg: string | null } {
        if (this.systemRequired) {
            return {erasable: false, msg: "You cannot delete this value, because it is set as system value."};
        }
        return {erasable: true, msg: null};
    }
}


// WEBPACK FOOTER //
// ./app/components/bo-core/models/AttributeValue.ts